"use strict";

var _slicedToArray = require("/home/circleci/project/web-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _nestedCard = require("./nestedCard.tokens");
var _NestedCardHeader = _interopRequireDefault(require("./NestedCardHeader"));
var _jsxRuntime = require("react/jsx-runtime");
var _NestedCard = function NestedCard(props) {
  var colorTheme = props.colorTheme,
    children = props.children,
    dataCy = props.dataCy;
  var _ref = (0, _react.useState)(false),
    _ref2 = _slicedToArray(_ref, 2),
    expanded = _ref2[0],
    setExpanded = _ref2[1];
  var onExpand = function onExpand() {
    setExpanded(!expanded);
  };
  var hasCollapsibleContent = false;
  var hasSummaryContainer = false;
  _react.default.Children.forEach(children, function (child) {
    if (/*#__PURE__*/_react.default.isValidElement(child) && child.type === _NestedCard.CollapsibleContent) {
      hasCollapsibleContent = true;
    }
    if (/*#__PURE__*/_react.default.isValidElement(child) && child.type === _NestedCard.SummaryContainer) {
      hasSummaryContainer = true;
    }
  });
  var childrenWithProps = _react.default.Children.map(children, function (child) {
    if (/*#__PURE__*/_react.default.isValidElement(child) && (child.type === _NestedCard.Header || child.type === _NestedCard.CollapsibleContent)) {
      var childNode = child;
      return /*#__PURE__*/_react.default.cloneElement(childNode, {
        onExpand: onExpand,
        colorTheme: colorTheme,
        expanded: expanded,
        hasCollapsibleContent: hasCollapsibleContent
      });
    }
    return child;
  });
  var className = "nested-card-".concat(props.colorTheme);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(Wrapper, {
    colorTheme: colorTheme,
    expanded: expanded,
    "data-cy": dataCy,
    className: className,
    hasSummaryContainer: hasSummaryContainer,
    children: childrenWithProps
  });
};
var Wrapper = _styledComponents.default.div.withConfig({
  displayName: "NestedCard__Wrapper",
  componentId: "sc-1mphmeb-0"
})(["background-color:", ";padding:", ";padding-bottom:", ";border-radius:", ";"], function (props) {
  return _nestedCard.nestedCardTokens.colorTheme[props.colorTheme].headerBackground;
}, function () {
  var padding = _nestedCard.nestedCardTokens.padding.wrapper;
  return "0 ".concat(padding, " 0 ").concat(padding);
}, function (props) {
  return props.hasSummaryContainer ? props.expanded ? _nestedCard.nestedCardTokens.padding.wrapper : _nestedCard.nestedCardTokens.padding.wrapperBottomUnexpanded : props.expanded ? _nestedCard.nestedCardTokens.padding.wrapper : "0px";
}, _nestedCard.nestedCardTokens.borderRadius);
var Content = _styledComponents.default.div.withConfig({
  displayName: "NestedCard__Content",
  componentId: "sc-1mphmeb-1"
})(["background-color:", ";padding:", ";"], _nestedCard.nestedCardTokens.color.subcontainerBackground, _nestedCard.nestedCardTokens.padding.content);
var SummaryContainer = (0, _styledComponents.default)(Content).withConfig({
  displayName: "NestedCard__SummaryContainer",
  componentId: "sc-1mphmeb-2"
})(["padding:", ";margin-bottom:", ";"], _nestedCard.nestedCardTokens.padding.summary, _nestedCard.nestedCardTokens.margin.summaryBottom);
var NestedCardCollapsibleContent = function NestedCardCollapsibleContent(props) {
  var expanded = props.expanded,
    colorTheme = props.colorTheme,
    children = props.children;
  var childrenWithProps = _react.default.Children.map(children, function (child) {
    if (/*#__PURE__*/_react.default.isValidElement(child)) {
      var childNode = child;
      return /*#__PURE__*/_react.default.cloneElement(childNode, {
        colorTheme: colorTheme
      });
    }
    return child;
  });
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_jsxRuntime.Fragment, {
    children: expanded && childrenWithProps
  });
};
_NestedCard.Header = _NestedCardHeader.default;
_NestedCard.Content = Content;
_NestedCard.SummaryContainer = SummaryContainer;
_NestedCard.CollapsibleContent = NestedCardCollapsibleContent;
var _default = exports.default = _NestedCard;